import React from 'react';
import { Link } from 'react-router-dom';

// patient_number is stored as PAT-000123; legacy labels may contain PAT-PAT-000123
const OBJECT_ID_PATTERN = /(PAT(?:-PAT)?-\d+|ADM-\d+)/g;
const HAS_OBJECT_ID = /PAT(?:-PAT)?-\d+|ADM-\d+/;

const normalizePatientIdDisplay = (part) => part.replace(/^PAT-PAT-/, 'PAT-');

const admissionHrefFromPart = (part, objectLink) => {
  if (objectLink) return objectLink;
  const match = /^ADM-(\d+)$/.exec(part);
  return match ? `/admission-card?admissionId=${match[1]}` : null;
};

const ConversationObjectLabel = ({ conversation, onNavigate, className }) => {
  const { object_type, object_id, object_label, object_link, patient_link } = conversation;

  if (!object_label || object_type === 'general' || !HAS_OBJECT_ID.test(object_label)) {
    return <span className={className}>{object_label}</span>;
  }

  const admissionOriginLink = object_type === 'admission'
    ? (object_link || (object_id ? `/admission-card?admissionId=${object_id}` : null))
    : null;

  const parts = object_label.split(OBJECT_ID_PATTERN);

  return (
    <span className={className}>
      {parts.map((part, index) => {
        let href = null;

        if (/^PAT/.test(part)) {
          // Patient tasks → patient card. Admission tasks → admission card (origin of the task).
          href = object_type === 'admission'
            ? admissionOriginLink
            : (patient_link || (object_type === 'patient' ? object_link : null));
        } else if (/^ADM-/.test(part)) {
          href = object_type === 'admission'
            ? admissionHrefFromPart(part, admissionOriginLink)
            : null;
        }

        if (href) {
          return (
            <Link
              key={`${part}-${index}`}
              to={href}
              onClick={onNavigate}
              className="messages-object-id-link"
            >
              {/^PAT/.test(part) ? normalizePatientIdDisplay(part) : part}
            </Link>
          );
        }

        return <span key={`${part}-${index}`}>{part}</span>;
      })}
    </span>
  );
};

export default ConversationObjectLabel;
